<template>
  <img class="avatar" :src="avatar" />
</template>

<script>
import "core-js/features/string/replace-all";
import gameStateStore from "@/stores/GameStateStore";

const avetars = [
  require("@/assets/avatars/avatars-01.svg"),
  require("@/assets/avatars/avatars-02.svg"),
  require("@/assets/avatars/avatars-03.svg"),
  require("@/assets/avatars/avatars-04.svg"),
  require("@/assets/avatars/avatars-05.svg"),
  require("@/assets/avatars/avatars-06.svg"),
];

export default {
  name: "Avatar",
  props: {
    name: String,
  },
  computed: {
    avatar() {
      const hash =
        (this.name.codePointAt(0) +
          this.name.codePointAt(this.name.length - 1)) %
        avetars.length;

      return avetars[hash];
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 49px;
  height: 49px;
}
</style>
